/*
 HOME LOGIC
 */

home = {
    init: function () {
        home.cE();
    },

    cE: function cacheElements() {
        home.journeyTabs = $('.tab');
        home.mobileTabs = $('.collapsible-link');
        home.el();
        home.rE();
    } ,
    el: function eventListeners() {
        if (gliv.returnWindowWidth() > 768){
            home.desktopClickEvent();
        } else {
            home.mobileClickEvent();
        }
    },
    rE: function resizeEvents(){
        //$(window).on('resize', function () {
        //    if (gliv.returnWindowWidth() > 768){
        //        home.desktopClickEvent();
        //    } else {
        //        home.mobileClickEvent();
        //    }
        //});
    },
    desktopClickEvent: function(){
        $.each(home.journeyTabs, function(){
            $(this).on('click', function(e){
                e.preventDefault();
                let content = $(this).data('id');
                $('.tab.active-tab').removeClass('active-tab');
                $('.content-item.show-content').removeClass('show-content');
                $(this).addClass('active-tab');
                $('#'+content).addClass('show-content');
            });
        });
    },
    mobileClickEvent: function(){
        $(home.mobileTabs).on('click', home.addCollapsibleFunctionality);
    },
    addCollapsibleFunctionality: function(){
        /*
         If collapsible section is already open close it, otherwise open it
         NOTE: These sections do not care if other collapsible sections are open already, we are only looking to see if the one clicked is open or closed.
         */
        if ($(this).parent().hasClass('collapsible-open')) {
            $(this).parent().removeClass('collapsible-open');
            if($(this).hasClass('border-bottom')){
                let thisEl = $(this);
                setTimeout(function(){
                    thisEl.removeClass('hide-border-bottom');
                }, 400);
            }
            $(this).siblings('.collapsible-copy').slideUp(400);
        } else {
            $(this).parent().addClass('collapsible-open');
            if($(this).hasClass('border-bottom')){
                $(this).addClass('hide-border-bottom');
            }
            $(this).siblings('.collapsible-copy').slideDown(400);
        }
    }
}
